import React from "react";
import { Search } from "lucide-react";
import { useLocale } from "@/lib/locale";

const HERO_BG = "https://images.pexels.com/photos/3709369/pexels-photo-3709369.jpeg";

export default function SearchHero({ query, setQuery, onSubmit }) {
  const { t } = useLocale();
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={HERO_BG} alt="" className="h-full w-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/40 via-obsidian/70 to-obsidian" />
      </div>

      <div className="max-w-5xl mx-auto px-6 pt-24 pb-20 sm:pt-32 sm:pb-28 grain relative">
        <div className="mb-8 inline-flex items-center gap-2 px-3 py-1 rounded-full border border-amber/30 bg-amber/5 text-amber text-xs uppercase tracking-[0.22em] font-heading">
          <span className="h-1.5 w-1.5 rounded-full bg-amber animate-pulse" />
          {t("brand_tagline")}
        </div>

        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.05] tracking-tight">
          {t("hero_title_1")} <em className="text-amber not-italic">{t("hero_title_2")}</em>
          <br className="hidden sm:block" /> {t("hero_title_3")}
        </h1>
        <p className="mt-6 max-w-2xl text-zinc-400 text-base sm:text-lg font-body">
          {t("hero_subtitle")}
        </p>

        <form
          onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }}
          className="mt-10 glass-strong rounded-md p-2 flex items-center gap-2 shadow-[0_30px_80px_-30px_rgba(245,166,35,0.25)]"
        >
          <div className="flex items-center pl-4 pr-2 text-amber">
            <Search className="h-6 w-6" strokeWidth={1.75} />
          </div>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("search_placeholder")}
            className="flex-1 bg-transparent outline-none text-xl sm:text-2xl py-5 placeholder:text-zinc-600 text-white font-display"
            data-testid="hero-search-input"
            autoFocus
          />
          <button
            type="submit"
            className="hidden sm:inline-flex items-center gap-2 bg-amber hover:bg-amber-hover text-obsidian font-heading font-medium px-6 py-3 rounded-md transition shadow-[0_8px_30px_-10px_rgba(245,166,35,0.55)]"
            data-testid="hero-search-submit"
          >
            {t("search_btn")}
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center gap-2 text-xs font-heading text-zinc-500">
          <span className="uppercase tracking-[0.22em]">{t("trending")}</span>
          {["Oppenheimer", "Dune: Part Two", "Poor Things", "The Bear", "Chernobyl"].map((tt) => (
            <button
              key={tt}
              onClick={() => { setQuery(tt); onSubmit?.(tt); }}
              className="px-3 py-1 rounded-full border border-white/10 hover:border-amber/50 hover:text-amber transition"
              data-testid={`trending-chip-${tt.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {tt}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
